{
  "navigation": {
    "products": "Nos produits",
    "pricing": "Nos tarifs",
    "testimonials": "Avis",
    "blog": "Blog",
    "freeQuote": "Devis gratuit",
    "tagline": "Créateur de souvenirs"
  },
  "header": {
    "title": "Votre année scolaire mérite mieux qu'une galerie photo oubliée",
    "subtitle": "Confiez-nous vos souvenirs, on les transforme en un livre que toute la promo voudra garder. Imaginé avec vous, imprimé en France sur papier recyclé et livré chez vous,",
    "description": "c'est un objet à feuilleter encore dans dix ans.",
    "formTitle": "Obtenez votre devis gratuit",
    "formName": "Nom",
    "formEmail": "Email",
    "formPhone": "Téléphone",
    "formOrganization": "Établissement",
    "formSubmit": "Obtenir mon devis",
    "formSubmitting": "Envoi...",
    "formMessage": "Décrivez votre projet...",
    "formQuoteDelay": "Réponse sous 24 h · sans engagement",
    "downloadEbook": "Télécharger notre ebook gratuit",
    "partnerSchools": "Écoles partenaires",
    "madeInFrance": "Made in France",
    "counters": {
      "yearbooks": "yearbooks déjà créés",
      "satisfaction": "de clients satisfaits",
      "years": "ans d'expérience"
    }
  },
  "services": {
    "title": "Créez votre yearbook en 3 étapes",
    "subtitle": "Transformez vos souvenirs en un livre unique.",
    "subtitleBreak": "Simple, rapide et personnalisé.",
    "step1": {
      "title": "On cadre votre projet",
      "description": "Formule, budget, planning, validés avec un conseiller dédié."
    },
    "step2": {
      "title": "Vos photos prennent vie",
      "description": "Vous créez en ligne, ou nos graphistes le font pour vous."
    },
    "step3": {
      "title": "On imprime et on livre",
      "description": "Fabrication française, livré dans votre établissement."
    },
    "learnMore": "En savoir plus sur le processus"
  },
  "products": {
    "title": "Découvrez nos Yearbooks",
    "subtitle": "Des formats adaptés à tous les budgets, de la maternelle à l'université.",
    "from": "À partir de",
    "perUnit": "/ unité",
    "details": "Voir les détails",
    "popular": "Populaire",
    "degressivePricing": "Des tarifs dégressifs sont appliqués selon la quantité.",
    "miniBudget": {
      "title": "Mini-Budget",
      "subtitle": "Pour écoles & lycées",
      "description": "L'essentiel pour garder vos souvenirs"
    },
    "classic": {
      "title": "Classique",
      "subtitle": "Pour universités",
      "description": "Le meilleur rapport qualité-prix"
    },
    "premium": {
      "title": "Premium",
      "subtitle": "Pour associations & entreprises",
      "description": "Pour des souvenirs d'exception"
    },
    "features": {
      "pages20to32": "De 20 à 32 pages",
      "stapled": "Agrafé",
      "priceFor150": "Prix indiqué pour une commande de 300 exemplaires",
      "from36pages": "À partir de 48 pages",
      "softCover": "Couverture souple",
      "squareBack": "Dos carré collé",
      "from32pages": "À partir de 32 pages",
      "hardCover": "Couverture rigide cartonnée"
    }
  },
  "pricing": {
    "title": "Un accompagnement créatif sur mesure !",
    "subtitle": "Des formules design claires, adaptées à tous selon l'accompagnement créatif souhaité.",
    "evolveOffer": "Vous pouvez faire évoluer votre offre au courant du projet !",
    "bestSeller": "Best Seller",
    "essential": {
      "name": "Essentielle",
      "subtitle": "Votre Yearbook\nen quelques clics! 💪",
      "description": "Une plateforme intuitive et riche en design pour votre créativité !",
      "price": "Gratuit"
    },
    "serenity": {
      "name": "Sérénité",
      "subtitle": "Un Yearbook parfait avec l'aide de nos experts Graphistes 🧑‍🎨",
      "description": "Un accompagnement graphique approfondi avec nos experts en design !",
      "price": "450€"
    },
    "custom": {
      "name": "Sur mesure",
      "subtitle": "Un Yearbook sur-mesure selon vos envies 🎨",
      "description": "La création de votre Yearbook\nde A à Z par nos experts !",
      "price": "1150€"
    },
    "features": {
      "followUp": "Accompagnement Suivi",
      "editor": "Editeur Yearbook",
      "designsStickers": "(+ de 250 designs & 1500 stickers)",
      "graphistExchanges": "Echange(s) graphistes",
      "digitalYearbook": "Yearbook Digital",
      "customCreation": "Création sur-mesure",
      "cover": "Couverture",
      "interior": "Intérieur",
      "trombi": "Trombi",
      "bonusUpload": "Bonus : Upload de vos contenus",
      "yes": "Oui",
      "no": "Non"
    },
    "chooseFormula": "Choisir cette formule"
  },
  "demos": {
    "title": "Nos exemples",
    "titleHighlight": "de réalisations",
    "subtitle": "Découvrez nos réalisations pour chaque niveau scolaire.",
    "viewYearbook": "Voir le yearbook",
    "filters": {
      "all": "Tous",
      "primary": "Primaire",
      "middle": "Collège",
      "high": "Lycée",
      "university": "Université"
    }
  },
  "testimonials": {
    "title": "Ils nous font confiance",
    "subtitle": "Découvrez les témoignages de nos clients satisfaits.",
    "whatTheySay": "Ce qu'ils disent de nous",
    "clientTypes": {
      "engineeringSchool": "École d'ingénieurs",
      "businessSchool": "École de commerce",
      "europeanSchool": "École européenne",
      "internationalSchool": "École internationale",
      "establishment": "Établissement",
      "citySchool": "Cité Scolaire",
      "school": "École",
      "politicalScience": "École de sciences politiques",
      "midwiferySchool": "École de sages-femmes",
      "universityInstitute": "Institut universitaire",
      "managementSchool": "École de management",
      "company": "Entreprise",
      "foundation": "Fondation",
      "event": "Événement",
      "hospitality": "Hôtellerie",
      "fashion": "Mode",
      "union": "Syndicat"
    }
  },
  "team": {
    "title": "Notre équipe",
    "subtitle": "Une équipe engagée et toujours à votre écoute.",
    "members": {
      "hubert": {
        "role": "Fondateur",
        "description": "Hubert, entrepreneur passionné, a fondé 1Year1Book en France avec le rêve de démocratiser l'univers des Yearbooks et de créer des souvenirs inoubliables."
      },
      "lynda": {
        "role": "Pôle Commercial",
        "description": "Lynda vous accompagne avec bienveillance dans la mise en œuvre de vos projets Yearbook. À l'écoute de vos besoins, elle met tout en œuvre pour garantir leur réussite."
      },
      "charlotteB": {
        "role": "Pôle Communication",
        "description": "Créative, Shaima développe notre image de marque en mettant en place des partenariats stratégiques pour accroître notre visibilité, tout en créant du contenu qui valorise pleinement le Yearbook."
      },
      "raphaelle": {
        "role": "Pôle Relation Client",
        "description": "Attentive et réactive, Raphaëlle vous garantit une expérience client exceptionnelle à chaque étape de votre projet."
      },
      "charlotteR": {
        "role": "Pôle Design",
        "description": "Charlotte propose des designs uniques qui transforment chaque Yearbook en œuvre d'art personnalisée."
      },
      "cedric": {
        "role": "Pôle Tech",
        "description": "C'est l'expert technique de 1Year1Book. Cédric veille à ce que nous restions à la pointe de la technologie pour toujours vous offrir des solutions modernes et innovantes."
      }
    }
  },
  "yearbookGallery": {
    "title": "Des Yearbooks pour tous !",
    "subtitle": "Explorez nos exemples inspirants, pensés pour chaque promo, de la maternelle aux études supérieures.",
    "viewCatalogue": "Voir notre catalogue",
    "categories": {
      "primary": "Ecoles Primaires",
      "middle": "Collèges",
      "high": "Lycées",
      "university": "Universités et Grandes Écoles",
      "leisureCenter": "Classe",
      "camps": "Colonies de vacances"
    },
    "categoryDescriptions": {
      "primary": "Yearbooks spécialement conçus pour les écoles élémentaires avec des designs colorés et ludiques.",
      "middle": "Des yearbooks modernes adaptés aux collégiens avec des mises en page dynamiques.",
      "high": "Yearbooks élégants pour immortaliser les années lycée avec style.",
      "university": "Des yearbooks professionnels pour les grandes écoles et universités.",
      "leisureCenter": "Yearbooks fun et colorés pour les centres de loisirs et activités périscolaires.",
      "camps": "Des souvenirs inoubliables des colonies de vacances dans un format unique."
    },
    "features": {
      "childDesign": "Design adapté aux enfants",
      "colorfulPages": "Pages colorées",
      "resistantFormat": "Format résistant",
      "activitiesIncluded": "Activités incluses",
      "modernLayout": "Mise en page moderne",
      "classPhotos": "Photos de classe",
      "socialPages": "Pages réseaux sociaux",
      "activitiesSection": "Section activités",
      "elegantDesign": "Design élégant",
      "seniorYear": "Année de terminale",
      "promSection": "Section bal de promo",
      "alumniDirectory": "Annuaire des anciens",
      "professionalFormat": "Format professionnel",
      "alumniSection": "Section alumni",
      "careerPages": "Pages carrières",
      "eventCoverage": "Couverture événements",
      "funDesign": "Design fun",
      "activityPhotos": "Photos d'activités",
      "groupPages": "Pages de groupe",
      "memoriesSection": "Section souvenirs",
      "adventureDesign": "Design aventure",
      "campPhotos": "Photos de camp",
      "adventurePages": "Pages aventures",
      "friendsSection": "Section amis"
    },
    "viewCatalogue": "Voir le catalogue"
  },
  "footer": {
    "contactForm": "Formulaire de contact",
    "launchNow": "Lancez-vous dès maintenant !",
    "name": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "message": "Message",
    "send": "Envoyer",
    "sending": "Envoi...",
    "contactInfo": "Nos coordonnées",
    "address": "Adresse",
    "followUs": "Suivez-nous",
    "hours": "Horaires",
    "hoursValue": "Lun - Ven : 9h - 18h",
    "weekendClosed": "Samedi / Dimanche",
    "closed": "Fermé",
    "legalLinks": "Liens légaux",
    "legalNotice": "Mentions légales",
    "privacy": "Politique de confidentialité",
    "terms": "CGV",
    "faq": "FAQ",
    "copyright": "Tous droits réservés."
  },
  "common": {
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "close": "Fermer",
    "submit": "Envoyer",
    "cancel": "Annuler",
    "previous": "Précédent",
    "next": "Suivant",
    "fillRequired": "Veuillez remplir tous les champs obligatoires."
  },
  "thankYou": {
    "title": "Merci !",
    "message": "Votre demande a bien été envoyée. Nous vous contacterons dans les plus brefs délais."
  },
  "quote": {
    "title": "Demande de devis",
    "selectFormula": "Sélectionnez une formule",
    "quantity": "Nombre d'exemplaires estimé",
    "establishment": "Établissement",
    "level": "Niveau scolaire",
    "levels": {
      "primary": "Primaire",
      "middle": "Collège",
      "high": "Lycée",
      "university": "Université",
      "other": "Autre"
    }
  },
  "cse": {
    "solutionBadge": "Solution CSE",
    "heroTitle": "Le BAI – Bilan d'Activités Individuel",
    "heroDescription": "1Year1Book accompagne les CSE dans la création de leur BAI, un document personnalisé remis à chaque salarié pour valoriser les avantages accordés.",
    "launchButton": "Lancez-vous !",
    "baiDistributed": "BAI distribués",
    "whatIsBai": "Qu'est-ce que le BAI ?",
    "whatIsBaiDescription": "Le BAI synthétise, de manière claire, graphique et chiffrée, l'ensemble des avantages accordés par le CSE sur une année :",
    "baiCategories": {
      "leisureCulture": "Loisirs et culture",
      "vacationsTravel": "Vacances et voyages",
      "socialAid": "Aides sociales",
      "internalEvents": "Événements internes",
      "catering": "Restauration",
      "sportsWellness": "Sport et bien-être"
    },
    "whyChooseBai": "Pourquoi choisir le BAI ?",
    "whyChooseBaiSubtitle": "Le meilleur outil de communication du CSE pour valoriser son travail, renforcer la transparence et l'adhésion des salariés",
    "benefits": {
      "personalizedDocument": "Document personnalisé",
      "personalizedDocumentDesc": "Chaque salarié reçoit son propre bilan avec ses données individuelles",
      "clearVisualization": "Visualisation claire",
      "clearVisualizationDesc": "Graphiques et chiffres pour une lecture immédiate des avantages",
      "benefitsHighlight": "Valorisation des avantages",
      "benefitsHighlightDesc": "Mise en lumière concrète du pouvoir d'achat gagné",
      "totalTransparency": "Transparence totale",
      "totalTransparencyDesc": "Renforce la confiance et la compréhension des actions du CSE",
      "electoralTool": "Outil électoral puissant",
      "electoralToolDesc": "Valorisez le travail accompli et renforcez l'adhésion des salariés"
    },
    "howItWorks": "Comment ça marche ?",
    "howItWorksSubtitle": "Un processus simple et efficace pour valoriser vos actions CSE",
    "steps": {
      "step1": "Transmission des données",
      "step1Desc": "Vous nous transmettez les données des avantages par salarié de manière sécurisée",
      "step2": "Création des BAI",
      "step2Desc": "Nous créons les bilans personnalisés avec vos couleurs et votre identité visuelle",
      "step3": "Distribution",
      "step3Desc": "Chaque salarié reçoit son BAI imprimé ou en format digital"
    },
    "theyTrustUs": "Ils nous font confiance",
    "theyTrustUsSubtitle": "Des entreprises de renom nous font confiance pour valoriser leurs actions CSE",
    "ctaTitle": "Prêt à valoriser vos actions CSE ?",
    "ctaSubtitle": "Renforcez la transparence, la compréhension des actions du CSE",
    "ctaSubtitle2": "et l'adhésion des salariés.",
    "footerCopyright": "© 2026 1Year1Book SAS - Tous droits réservés",
    "banner": {
      "powerfulTool": "Outil de communication très puissant",
      "optimalCommunication": "Communication optimale auprès des salariés",
      "cseWorkValorization": "Valorisation du travail du CSE",
      "teamAdhesion": "Renforcement de l'adhésion des équipes",
      "totalTransparency": "Transparence totale des avantages"
    },
    "dialog": {
      "title": "Lancez-vous !",
      "description": "Remplissez ce formulaire et notre équipe vous contactera pour créer votre BAI personnalisé.",
      "nameLabel": "Nom / Prénom *",
      "namePlaceholder": "Jean Dupont",
      "organizationLabel": "Organisation *",
      "organizationPlaceholder": "CSE de votre entreprise",
      "phoneLabel": "Téléphone",
      "phonePlaceholder": "06 12 34 56 78",
      "emailLabel": "Email *",
      "emailPlaceholder": "jean.dupont@entreprise.fr",
      "submitButton": "Envoyer ma demande",
      "submitting": "Envoi en cours...",
      "thankYouTitle": "Merci !",
      "thankYouMessage": "Votre demande a bien été envoyée. Notre équipe vous contactera très prochainement.",
      "closeButton": "Fermer",
      "errorRequired": "Veuillez remplir tous les champs obligatoires.",
      "errorSend": "Une erreur est survenue lors de l'envoi. Veuillez réessayer."
    }
  },
  "ambassadors": {
    "badge": "Programme Ambassadeurs",
    "heroTitle": "Devenez Ambassadeur 1Year1Book",
    "heroDescription": "Faites découvrir le projet Yearbook autour de vous et recevez une commission attractive pour chaque projet lancé grâce à vous !",
    "becomeAmbassador": "Devenir Ambassadeur",
    "missionBadge1": "Mission 1",
    "missionBadge2": "Mission 2",
    "missionsTitle": "Vos missions principales",
    "missionsSubtitle": "Un rôle d'initiateur, sans charge opérationnelle : ni vente, ni négociation, ni production, ni suivi.",
    "seeList": "Voir la liste",
    "schoolsListTitle": "Établissements hors réseau partenaire",
    "missions": {
      "identify": {
        "title": "Identifier",
        "description": "Contactez des établissements hors réseau partenaire susceptibles d'être intéressés par un Yearbook."
      },
      "detect": {
        "title": "Détecter",
        "description": "Repérez un projet Yearbook réel et structuré pour l'année en cours ou à venir."
      },
      "connect": {
        "title": "Mettre en relation",
        "description": "Transmettez le contact qualifié à notre équipe qui prendra le relais."
      }
    },
    "whatYouDoTitle": "Ce que vous faites concrètement",
    "whatYouDoSubtitle": "Un processus simple en 4 étapes",
    "steps": {
      "contact": {
        "title": "Prenez contact",
        "description": "Contactez l'établissement de votre réseau"
      },
      "present": {
        "title": "Présentez le concept",
        "description": "Expliquez brièvement le Yearbook"
      },
      "verify": {
        "title": "Vérifiez les critères",
        "description": "Intérêt réel, projet structuré, min. 50 exemplaires"
      },
      "transmit": {
        "title": "Transmettez-nous",
        "description": "Envoyez le contact qualifié à notre équipe"
      }
    },
    "noSaleNegotiation": "Un rôle d’initiateur, sans charge opérationnelle : ni vente, ni négociation, ni production, ni suivi.",
    "remunerationBadge": "Rémunération attractive",
    "remunerationTitle": "Une commission progressive selon vos résultats",
    "remunerationDescription": "Plus vous apportez de projets, plus votre taux de commission augmente. Un système transparent et motivant.",
    "minimum50": "Minimum 50 exemplaires par contrat",
    "basedOnOrders": "Calcul basé sur les exemplaires commandés et payés",
    "paymentAfterSignature": "Paiement sous 30 jours après validation",
    "whyBecomeTitle": "Pourquoi devenir ambassadeur ?",
    "why": {
      "simple": {
        "title": "Un rôle simple",
        "description": "Repérez des opportunités, transmettez-les, et générez des revenus complémentaires"
      },
      "transparent": {
        "title": "Rémunération transparente",
        "description": "Commission claire et versée après chaque projet validé et payé."
      },
      "noConstraint": {
        "title": "Zéro contrainte",
        "description": "Pas de négociation, pas de suivi projet, pas de production à gérer."
      },
      "humanValue": {
        "title": "Projet à forte valeur humaine",
        "description": "Souvenir marquant pour les élèves, impact émotionnel durable."
      }
    },
    "weHandleTitle": "Ce que nous prenons en charge",
    "weHandleSubtitle": "Une fois la mise en relation effectuée, notre équipe assure l'intégralité du projet.",
    "weHandle": {
      "structuring": "La structuration précise du besoin",
      "proposal": "La proposition commerciale et contractuelle",
      "coordination": "La coordination avec l'établissement",
      "design": "Le design, la production et la livraison"
    },
    "validConditionsTitle": "Conditions de validation",
    "validConditionsSubtitle": "Un lead est considéré comme valide si :",
    "conditions": {
      "notPartner": "L'établissement n'est pas déjà partenaire",
      "newContact": "Le contact transmis est nouveau",
      "signedContract": "Le projet aboutit à un contrat signé",
      "minimum50": "La commande atteint au minimum 50 exemplaires"
    },
    "contactTitle": "Rejoignez notre programme",
    "contactSubtitle": "Remplissez le formulaire et notre équipe vous contactera",
    "form": {
      "name": "Nom complet",
      "namePlaceholder": "Jean Dupont",
      "email": "Email",
      "emailPlaceholder": "jean.dupont@email.com",
      "phone": "Téléphone",
      "phonePlaceholder": "06 12 34 56 78",
      "message": "Message (optionnel)",
      "messagePlaceholder": "Parlez-nous de votre réseau ou posez vos questions...",
      "submit": "Devenir Ambassadeur",
      "successTitle": "Candidature envoyée !",
      "successMessage": "Merci pour votre intérêt. Notre équipe vous contactera très prochainement."
    },
    "footerRights": "Tous droits réservés",
    "banner": {
      "simpleRole": "Rôle simple et valorisant",
      "attractiveRemuneration": "Rémunération attractive",
      "zeroConstraint": "Zéro contrainte opérationnelle",
      "humanProject": "Projet à forte valeur humaine",
      "networkOpportunity": "Opportunité réseau"
    }
  }
}
